// "75" -> "1h 15m", "42" -> "42m", "120" -> "2h"
export const formatMinutes = (totalMinutes) => {
  const minutes = Math.max(0, Math.round(Number(totalMinutes) || 0));
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}m`;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
};

export const formatRupees = (amount) => {
    const value = Number(amount) || 0;
    return `${value < 0 ? '-' : ''}₹${Math.abs(value).toLocaleString('en-IN')}`;
};
